import { render, staticRenderFns } from "./playText.vue?vue&type=template&id=4f2eae6c&scoped=true"
import script from "./playText.vue?vue&type=script&lang=js"
export * from "./playText.vue?vue&type=script&lang=js"
import style0 from "./playText.vue?vue&type=style&index=0&id=4f2eae6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2eae6c",
  null
  
)

export default component.exports